"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakpointVariantClassName = void 0;
var constants_1 = require("./constants");
var getBreakpointVariantClassName = function (bp, value) {
    if (bp === 'def')
        return "" + value;
    return bp + ":" + value;
};
exports.getBreakpointVariantClassName = getBreakpointVariantClassName;
exports.default = (function (propValue, transform) {
    if (transform === void 0) { transform = function (value) { return "" + value; }; }
    if (Array.isArray(propValue)) {
        return propValue
            .map(function (value, index) {
            if (value === null)
                return false;
            var bp = constants_1.BREAKPOINTS[index];
            return exports.getBreakpointVariantClassName(bp, transform(value));
        })
            .filter(function (value) { return !!value; });
    }
    else if (typeof propValue === 'object') {
        return Object.keys(propValue).map(function (bp) {
            var value = propValue[bp];
            return exports.getBreakpointVariantClassName(bp, transform(value));
        });
    }
    return [transform(propValue)];
});
//# sourceMappingURL=responsiveProp.js.map